// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs-container.vertical .tab {
  padding: 5px;
  text-align: center;
  cursor: pointer;
}

.tabs-container.vertical {
  width: 50px;
  height: 92vh;
}
.tabs-container.vertical .tab.active {
  color: var(--primaryColor);
  background-color: var(--menuSelectColor);
  font-weight: bold;
}
.tabs-container.vertical .nav {
  display: block;
}
.tabs-container.vertical ul {
  background: #fff;
  width: 50px;
  margin-right: 1px;
  float: left;
  height: 92vh;
}
.tabs-container.vertical li {
  margin: 10px 0px;
}
.tabs-container.vertical .tab-content {
  background: transparent;
  visibility: hidden;
  min-width: 360px;
}
.tabs-container.vertical .tab-content.active {
  visibility: visible;
}
.tabs-container.vertical .pane::-webkit-scrollbar {
  display: none;
}

.tabs-container.vertical > :has(.active) .tab-content {
  width: 100%;
}

.right-box-shadow {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

@media screen and (max-width: 640px) {
  .tabs-container.vertical .tab-content {
    background: transparent;
    visibility: visible;
    min-width: 360px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/tabs/tabs.component.scss"],"names":[],"mappings":"AAiBC;EACC,YAAA;EACA,kBAAA;EACA,eAAA;AAhBF;;AAkBA;EACE,WAAA;EACA,YAAA;AAfF;AAgBE;EACK,0BAAA;EACA,wCAAA;EACA,iBAAA;AAdP;AAgBE;EACE,cAAA;AAdJ;AAgBE;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AAdJ;AAgBE;EACE,gBAAA;AAdJ;AAiBE;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;AAfJ;AAkBE;EACE,mBAAA;AAhBJ;AAmBE;EACE,aAAA;AAjBJ;;AAsBE;EACE,WAAA;AAnBJ;;AAsBA;EACE,iDAAA;AAnBF;;AAsBA;EAEI;IACE,uBAAA;IACA,mBAAA;IACA,gBAAA;EApBJ;AACF","sourcesContent":["// .tabs-container {\n//   width:320px;\n//   height: 200px;\n//   margin:0px 0px;\n// }\n\n// .tabs-container .tab:hover{\n\n//    border-radius:2px;\n//      opacity:90%;\n// }\n//  .tabs-container .tab.active{\n//    color:var(--primaryColor);\n//    background-color:var(--menuSelectColor);\n//    font-weight: bold;\n \n//    }\n .tabs-container.vertical .tab{\n  padding:5px;\n  text-align:center;\n  cursor: pointer;\n}\n.tabs-container.vertical{\n  width:50px;\n  height:92vh;\n  .tab.active{\n       color:var(--primaryColor);\n       background-color:var(--menuSelectColor);\n       font-weight: bold;\n     }\n  .nav{\n    display: block;\n  }\n  ul{\n    background: #fff;\n    width:50px;\n    margin-right:1px;\n    float: left;\n    height:92vh;\n  }\n  li{\n    margin:10px 0px;\n  }\n\n  .tab-content{\n    background:transparent;\n    visibility: hidden;\n    min-width:360px;\n  }\n\n  .tab-content.active{\n    visibility: visible;\n   }\n\n  .pane::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.tabs-container.vertical > :has(.active){\n  .tab-content{\n    width:100%;\n  }\n}\n.right-box-shadow{\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n}\n\n@media screen and (max-width:640px) {\n  .tabs-container.vertical{\n    .tab-content{\n      background:transparent;\n      visibility: visible;\n      min-width:360px;\n    }\n  }\n\n}\n\n \n// @media screen and (max-width:767px) {\n//   .tabs-container.vertical{\n//     display: flex;\n//     flex-direction: column;\n//     width:100%;\n//   }\n//   .tabs-container.vertical{\n//     ul{\n//       width:100%;\n//       height:50px;\n//     }\n//     .tab{\n//       width: 50px;\n//     float: left;\n//     margin: 5px 10px;\n//     display: flex;\n//     justify-content: space-evenly;\n//     }\n//   } \n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
